import {Component, Input, OnDestroy} from '@angular/core';
import {BehaviorSubject, ReplaySubject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {TorchUserService} from '@backend/modules/@users/services/torch-user.service';
import {TorchUser} from '@backend/modules/@users/models/torch-user.model';
import {animate, style, transition, trigger} from '@angular/animations';

@Component({
  selector: 'app-manage-user',
  templateUrl: './manage-user.component.html',
  styleUrls: ['./manage-user.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({opacity: 0}),
        animate(300, style({opacity: 1}))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(50, style({opacity: 0}))
      ])
    ])
  ]
})
export class ManageUserComponent implements OnDestroy {

  @Input()
  expanded = false;

  @Input()
  multiAccordion = true;

  totalUserFiles = new BehaviorSubject<number>(0);
  hasLoaded = new BehaviorSubject<boolean>(false);
  currentUser: TorchUser;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject(1);

  constructor(private torchUserService: TorchUserService) {
    this.hasLoaded.next(false);
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  fileCountUpdated(newVal) {
    this.totalUserFiles.next(newVal);
  }

  @Input()
  set user(newValue: string | null) {
    this.hasLoaded.next(false);
    this.totalUserFiles.next(0);

    if (!!newValue) {
      this.torchUserService.getUser(newValue).pipe(
        takeUntil(this.destroyed$)
      ).subscribe( torchUser => {
        this.currentUser = torchUser;
        this.hasLoaded.next(true);
      });
    }
  }
}
